import { render } from "./TheC01ItemForm.vue?vue&type=template&id=143a14c1&scoped=true&ts=true"
import script from "./TheC01ItemForm.vue?vue&type=script&lang=ts"
export * from "./TheC01ItemForm.vue?vue&type=script&lang=ts"

import "./TheC01ItemForm.vue?vue&type=style&index=0&id=143a14c1&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143a14c1"]])

export default __exports__